import { resetApiBaseUrl } from '../../utils/storage.js';
import StorageService from '../storage/storageService.js';

export const authService = {
  getToken() {
    try {
      const token = StorageService.getAuthToken();
      return token;
    } catch (err) {
      return null;
    }
  },

  setToken(token) {
    try {
      StorageService.setAuthToken(token);
    } catch (err) {
    }
  },

  removeToken() {
    try {
      StorageService.removeAuthToken();
      resetApiBaseUrl();
    } catch (err) {
    }
  },

  isAuthenticated() {
    return !!this.getToken();
  }
};
